"use client";

import React from "react";
import { motion } from "framer-motion";
import mentionsData from "@/content/mentions.json";
import Link from "next/link";
import ContentElement from "@/components/UI/ContentElement/ContentElement";

const mentions: any[] = mentionsData as any[];

const MentionsElement: React.FC = () => (
    <ContentElement
        heading="Wzmianki medialne"
        subheading="Mówią o nas"
        isWhite={true}
        className="bg-sectionbg p-28 w-full overflow-hidden relative [&>div:first-child]:text-center"
        childrenClassName="w-full"
    >
        <div className="w-full">
            {/* Marquee with the same look & animation */}
            <div
                style={{
                    width: "100%",
                    overflow: "hidden",
                    position: "relative",
                    maskImage:
                        "linear-gradient(to right, transparent 0, black 192px, black calc(100% - 192px), transparent 100%)",
                    WebkitMaskImage:
                        "linear-gradient(to right, transparent 0, black 192px, black calc(100% - 192px), transparent 100%)",
                }}
            >
                <motion.div
                    className="flex gap-[9rem] items-center"
                    style={{ width: "fit-content" }}
                    animate={{ x: ["0%", "-50%"] }}
                    transition={{
                        repeat: Infinity,
                        duration: 60,
                        ease: "linear",
                    }}
                >
                    {[...mentions, ...mentions].map((el, index) => (
                        <Link
                            key={index}
                            href={el.href}
                            className="select-none outline-none h-[11rem] min-w-[9rem] grayscale hover:grayscale-0 transition-all duration-300 flex items-center justify-center"
                        >
                            <img
                                src={el.src}
                                alt={el.alt}
                                className="h-[11rem] object-contain"
                            />
                        </Link>
                    ))}
                </motion.div>
            </div>
        </div>
    </ContentElement>
);

export default MentionsElement;
